<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3">스케줄 수행 이력</div>
      <el-button size="mini" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
    </el-row>
    <el-table-wrapper style="width:100%" ref="historyTable" :data="historyList" :total="total" :columns="columns" :column-default="columnDefault" :show-custom-header="true" remote
      :show-search-tool="showSearchTool" :highlight-current-row="true" @condition-change="loadData">
      <template slot-scope="scope" slot="status-slot">
        <span v-if="scope.row.jobStatus === '1'" class="state-normal">성공</span>
        <span v-else class="state-abnormal">실패</span>
      </template>
    </el-table-wrapper>
  </div>
</w-settings-content-template>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import ScheduleAPI from '@/api/settings/netdevice/schedule';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';

export default {
  name: 'WSchduleHistroy',
  components: {
    WSettingsContentTemplate,
  },
  data() {
    return {
      showSearchTool: false,
      columnDefault,
      columns: [
        {
          prop: 'jobStatus',
          label: '상태',
          width: 70,
          sortable: true,
          remoteProp: 'detail.job_status',
          scopedSlot: 'status-slot',
          filters: [
            {
              text: '성공',
              value: '1',
            },
            {
              text: '실패',
              value: '0',
            },
          ],
        },
        {
          prop: 'jobType',
          label: '구분',
          sortable: true,
          searchable: true,
          formatter: this.formatJobType,
          remoteProp: 'h.job_type',
        },
        {
          prop: 'jobName',
          label: '스케줄 구분',
          sortable: true,
          searchable: true,
          remoteProp: 'h.job_name',
        },
        {
          prop: 'scheduleName',
          label: '스케줄명',
          sortable: true,
          searchable: true,
          remoteProp: 's.schedule_name',
        },
        {
          prop: 'managerId',
          label: '등록자',
          sortable: true,
          searchable: true,
          remoteProp: 'h.manager_id',
        },
        {
          prop: 'checkDatetime',
          label: '수행일시',
          sortable: true,
          formatter: this.formatCheckDatetime,
          remoteProp: 'n.checkDatetime',
        },
        {
          prop: 'objCount',
          label: '수행 장비 수',
          sortable: true,
          formatter: this.formatObjCount,
        },
      ],
      historyList: [],
      total: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 스케쥴 이력을 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      const tableParams = this.$refs.historyTable.getParameter();
      const params = {
        ...tableParams,
      };

      ScheduleAPI.getJobHistory(params).then((response) => {
        if (response.data.success) {
          this.historyList = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    /**
     * 작업구분을 텍스트 형식으로 변환한다.
     * @param  {[type]} record [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatJobType(record, column, value) {
      if (value === 'M') {
        return '수동실행';
      } else if (value === 'S') {
        return '스케줄';
      }

      return EMPTY_TEXT;
    },
    /**
     * 스케쥴 수행 시간을 YYYY-MM-DD 형식으로 변환한다.
     * @param  {[type]} record [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatCheckDatetime(record, column, value) {
      return getDateToString(value);
    },
    /**
     * 수행 장비 수를 리턴한다.
     * @param  {[type]} record [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatObjCount(record, column, value) {
      return `${value}대`;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/ScheduleHistory.vue